<div class="frame" [ngSwitch]="filePreviewType" [class.document]="isDocument">
    <!-- Documents get a header bar with their type and the open button -->
    <div class="frame-document-header" *ngIf="isDocument">
        <mat-icon>{{ filePreviewType == FileTypes.PDF ? 'picture_as_pdf' : 'insert_drive_file' }}</mat-icon>
        <span>{{ filePreviewType == FileTypes.PDF ? 'Documento PDF' : 'Arquivo' }}</span>
        <a mat-stroked-button color="primary" class="frame-document-open" [href]="filePath" target="_blank" rel="noopener"
            *ngIf="allowHoverAction">
            <mat-icon>open_in_new</mat-icon> Abrir
        </a>
    </div>

    <iframe *ngSwitchCase="FileTypes.Unknown" [src]="filePath | safe: 'resourceUrl'"></iframe>
    <iframe *ngSwitchCase="FileTypes.PDF" [src]="filePath | safe: 'resourceUrl'"></iframe>
    <a *ngSwitchCase="FileTypes.Image" class="frame-image" [class.clickable]="allowHoverAction"
        [attr.href]="allowHoverAction ? filePath : null" target="_blank" rel="noopener"
        [attr.aria-label]="allowHoverAction ? 'Abrir imagem em tamanho original' : null">
        <img [src]="filePath | safe: 'resourceUrl'" alt="" onerror="this.src = 'assets/images/image_not_found.png'">
    </a>
    <video *ngSwitchCase="FileTypes.Video" class="frame-video" controls
        onloadedmetadata="this.muted = true; this.volume = 0.1;" #videoPlayer>
        <source [src]="filePath | safe: 'resourceUrl'" [type]="fileType">
        Your browser does not support the video tag.
    </video>

    <a class="frame-open" [href]="filePath" target="_blank" rel="noopener"
        *ngIf="allowHoverAction && filePreviewType == FileTypes.Image">
        <mat-icon>open_in_new</mat-icon> Abrir
    </a>

    <ng-container *ngIf="total > 1">
        <button type="button" class="frame-nav previous" (click)="move(-1)" [disabled]="index == 0"
            aria-label="Anexo anterior">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <button type="button" class="frame-nav next" (click)="move(1)" [disabled]="index == total - 1"
            aria-label="Próximo anexo">
            <mat-icon>chevron_right</mat-icon>
        </button>
        <span class="frame-counter">{{ index + 1 }} / {{ total }}</span>
    </ng-container>
</div>
